"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AltiumComponent = void 0;
const SchDocTypes_1 = require("../SchDocTypes");
class AltiumComponent {
    constructor(schematic, record) {
        this.schematic = schematic;
        this.record = record;
        this.childRecords = this.schematic.getChildRecords(this.record.index);
    }
    getPins() {
        return this.childRecords.filter((r) => r.recordType === SchDocTypes_1.RecordType.PIN);
    }
    getHiddenNetName(pin) {
        const parameters = this.schematic
            .getChildRecords(pin.index)
            .filter((record) => record.recordType === SchDocTypes_1.RecordType.PARAMETER);
        const parameter = parameters.find((record) => record.name.toLowerCase() === 'hiddennetname');
        const name = parameter?.text.trim();
        return name ? name : undefined;
    }
    getDesignator() {
        return this.childRecords.find((r) => r.recordType === SchDocTypes_1.RecordType.DESIGNATOR);
    }
    getParameters() {
        return this.childRecords.filter((r) => r.recordType === SchDocTypes_1.RecordType.PARAMETER);
    }
    getImplementationLists() {
        return this.childRecords
            .filter((r) => r.recordType === SchDocTypes_1.RecordType.IMPLEMENTATION_LIST)
            .map((r) => this.schematic.getImplementationListByIndex(r.index));
    }
    getDesignatorText() {
        return this.getDesignator()?.text;
    }
    getParameterValue(name) {
        const param = this.getParameters().find((p) => p.name === name);
        return param?.text;
    }
    getGraphics() {
        return this.childRecords.filter(SchDocTypes_1.isGraphicRecord);
    }
}
exports.AltiumComponent = AltiumComponent;
//# sourceMappingURL=AltiumComponent.js.map